/**
 * 견적서(Quote) 폼의 정적 선택지와 입력 상한.
 * 가격·할인·단체 최소조건은 Quiz 서버 정책을 사용한다.
 */

import { ALL_QUIZ_TYPES_FEATURE_COPY } from '@/shared/plan/consts';

export const QUOTE_PLAN_TYPES = ['individual', 'group'] as const;
export type QuotePlanType = (typeof QUOTE_PLAN_TYPES)[number];

export const QUOTE_PLANS = ['basic', 'pro'] as const;
export type QuotePlan = (typeof QUOTE_PLANS)[number];

/** 이용 기간·인원 상한 (Django 폼 미러) */
export const QUIZ_TERM_MAX = 24; // 개월
export const QUIZ_USER_COUNT_MAX = 100;

/** 사용 기간 select 옵션 (1~24개월) */
export const QUIZ_TERM_OPTIONS = Array.from(
  { length: QUIZ_TERM_MAX },
  (_, i) => ({ value: String(i + 1), label: `${i + 1}개월` }),
);

/** 플랜별 기능 리스트 (Figma "플랜 선택" 기능 그리드) */
export interface QuotePlanFeature {
  label: string;
  isAi?: boolean;
}
export const QUIZ_PLAN_FEATURES: Record<QuotePlan, QuotePlanFeature[]> = {
  basic: [
    { label: '베이직 전용 맵 이용' },
    { label: '비공개 퀴즈 만들기' },
    { label: 'AI로 문제 추가하기', isAi: true },
  ],
  pro: [
    { label: '모든 맵 무제한 이용' },
    { label: ALL_QUIZ_TYPES_FEATURE_COPY.defaultValue },
    { label: '학습 리포트(LMS)의 모든 기능' },
    { label: '다음 퀴즈 이어 풀기' },
    { label: '워크시트 저장' },
    { label: 'AI 학습도우미', isAi: true },
    { label: '문제 다국어 번역', isAi: true },
    { label: '유사 문제 만들기', isAi: true },
    { label: '보기·정답 만들기', isAi: true },
  ],
};

/** 프라이싱 진입 세그먼트 → 견적 프리필 (pricingTabQuery 와 값 정의를 맞춤) */
export const QUOTE_SEGMENTS = ['individual', 'group'] as const;
export type QuoteSegment = (typeof QUOTE_SEGMENTS)[number];
export const QUOTE_SEGMENT_QUERY_KEY = 'tab';

export function parseQuoteSegment(value: unknown): QuoteSegment {
  const v = Array.isArray(value) ? value[0] : value;
  return v === 'group' ? 'group' : 'individual';
}
